/* eslint-disable import/no-useless-path-segments */
import { lazy } from 'react';
import { RouteType } from '@utils/models';

import { rootPaths } from './rootPaths';

const Login = lazy(() => import('../pages/login/Login'));
const MainRouter = lazy(() => import('./main/MainRouter'));
const F4f = lazy(() => import('../components/f4f/F4f'));
const ShowroomV2 = lazy(() => import('@pages/showroom-v2/ShowroomV2'));
const BossPageRouter = lazy(() => import('./bossPage/BossRouter'));
const RootIntegration = lazy(() => import('../pages/rootIntegration/RootIntegration'));
const UyqurIntegration = lazy(() => import('../pages/rootIntegration/UyqurIntegration'));
const RestorePassword = lazy(() => import('../pages/restorePassword/RestorePassword'));
const ChangePassword = lazy(() => import('../pages/change-password/ChangePassword'));
const QrCode = lazy(() => import('../pages/qr-code/QrCode'));
const ScheduleLottotron = lazy(() => import('@pages/schedule-lottotron/ScheduleLottotron'));
const PrivacyPolicy = lazy(() => import('pages/privacy-policy'));
const Realtor = lazy(() => import('@pages/realtor-app'));
const aiAgentRoutes = lazy(() => import('../routing/ai-agent'));

const PaymentQrCode = lazy(() => import('../pages/payment-qr-code/index'));

export const rootRoutes: RouteType[] = [
  {
    path: rootPaths.INDEX,
    component: Login,
    exact: true
  },
  {
    path: rootPaths.MAIN,
    component: MainRouter,
    exact: false
  },
  {
    path: rootPaths.SHOWROOM,
    component: ShowroomV2,
    exact: false
  },
  {
    path: rootPaths.BOSS,
    component: BossPageRouter,
    exact: false
  },
  {
    path: rootPaths.INTEGRATION,
    component: RootIntegration,
    exact: false
  },
  {
    path: rootPaths.INTEGRATION_UYQUR,
    component: UyqurIntegration,
    exact: false
  },
  {
    path: rootPaths.RESTORE_PASSWORD,
    component: RestorePassword,
    exact: true
  },
  {
    path: rootPaths.CHANGE_PASSWORD,
    component: ChangePassword,
    exact: true
  },
  {
    path: rootPaths.QR_CODE,
    component: QrCode,
    exact: true
  },
  {
    path: rootPaths.SCHEDULE_LOTTOTRON,
    component: ScheduleLottotron,
    exact: true
  },
  {
    path: rootPaths.PRIVACY_POLICY,
    component: PrivacyPolicy,
    exact: true
  },
  {
    path: rootPaths.REALTOR,
    component: Realtor,
    exact: false
  },
  {
    path: rootPaths.PAYMENT_QR_CODE,
    component: PaymentQrCode,
    exact: true
  },
  {
    path: rootPaths.AI_AGENT,
    component: aiAgentRoutes,
    exact: false
  },
  {
    path: '*',
    component: F4f,
    exact: true
  }
];
